import { makeVar, useReactiveVar } from '@apollo/client'

// Set while the session extension dialog of this tab is open, see
// useIsSessionExpiryPaused
export const isExtendingSessionVar = makeVar(false)

export const useIsExtendingSession = () => useReactiveVar(isExtendingSessionVar)
